"use client"

import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { ParallaxProvider } from "react-scroll-parallax"
import { OdooConfig } from "./utilities/odoo-config"
import Odoo from "odoo-xmlrpc"
import AppRoutes from "./routes.js"
import Header from "./components/Header/Header"
import Footer from "./components/Footer/Footer"
import SplashScreen from "./components/Landing/SplashScreen"
import WhatsAppWidget from "./components/Contact/WhatsAppWidget"
import "./App.css"

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [contentVisible, setContentVisible] = useState(false)
  const location = useLocation()

  // Efecto para controlar el scroll y la posición inicial
  useEffect(() => {
    // Forzar la posición al inicio de la página cuando se carga la app
    window.scrollTo(0, 0)

    // Deshabilitar el scroll mientras se muestra el splash screen
    if (isLoading) {
      document.body.style.overflow = "hidden"
    } else {
      // Restaurar el scroll cuando se muestra el contenido principal
      document.body.style.overflow = ""

      // Asegurarse de que la página esté en la parte superior cuando se muestra el contenido
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto", // 'auto' es más confiable que 'smooth' para este caso
      })
    }

    return () => {
      // Limpiar al desmontar
      document.body.style.overflow = ""
    }
  }, [isLoading])

  useEffect(() => {
    const initializeData = async () => {
      try {
        const config = await OdooConfig()
        if (!config || (!config.host && !config.url)) {
          throw new Error("Configuración de Odoo incompleta")
        }

        const odoo = new Odoo({
          url: config.host || config.url,
          port: config.port || null,
          db: config.database,
          username: config.username,
          password: config.password,
        })
        console.log("Conexión Odoo establecida:", odoo)
      } catch (error) {
        console.error("Error al inicializar Odoo:", error)
      }
    }

    initializeData()
  }, [])

  const handleLoadingComplete = () => {
    // Asegurarse de que la página esté en la parte superior antes de quitar el splash screen
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    })

    // Quitar el splash screen
    setIsLoading(false)

    // Pequeño retraso para mostrar el contenido principal
    setTimeout(() => {
      setContentVisible(true)

      // Asegurarse nuevamente de que la página esté en la parte superior
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      })
    }, 100)
  }

  const isPlantillaServicios = location.pathname.startsWith("/servicios/")

  return (
    <ParallaxProvider>
      {isLoading && <SplashScreen onLoadingComplete={handleLoadingComplete} />}

      <div className={`App ${contentVisible ? "content-visible" : ""}`}>
        {!isPlantillaServicios && <Header />}

        <div className="content-wrapper">
          <AppRoutes />
        </div>

        <Footer />

        {/* Componente de WhatsApp flotante */}
        <WhatsAppWidget phoneNumber="573001079888" initialMessage="¡Hola! ¿En qué podemos ayudarte?" />
      </div>
    </ParallaxProvider>
  )
}

export default App

